import { Loading } from '@/components/Loading/Loading'
import { useRef, useState } from 'react'

interface ProductButtonType {
  type: string
  isProcessing?: boolean
  className?: string
  innerClassName?: string
  onClick: () => void
  isPreOrderButton?: boolean
  date?: number
  second?:string
}
export const ProductButton = ({
  type,
  onClick,
  isProcessing,
  className,
  innerClassName,
  isPreOrderButton = false,
  second = ''
}: ProductButtonType) => {
  const buttonRef = useRef(null)
  const [id, setId] = useState('')

  const renderBtn = (e: string) => {
    switch (e) {
      case 'add-to-cart':
        return {
          primary: 'Thêm vào giỏ',
          styleBtn: 'bg-[#FFFFFF] rounded-sm border border-[#FF0000]',
          stylePrimary: 'text-[#FF0000]',
          styleSecond: 'text-orange',
        }
      case 'contact':
        return {
          primary: 'Gọi lại cho tôi',
          second: '',
          styleBtn: 'bg-[#FFFFFF] rounded-sm border border-[#FF0000]',
          stylePrimary: 'text-[#FF0000]',
          styleSecond: 'text-white-400',
        }
      case 'outOfBusiness':
        return {
          primary: 'Ngừng kinh doanh',
          second: '',
          styleBtn:
            'border border-[#282828]',
          stylePrimary: 'text-[#000000]',
          styleSecond: 'text-[#000000]',
        }
      case 'buy-now':
        return {
          primary: 'Mua ngay',
          second: second,
          styleBtn: 'rounded-sm bg-[#FF0000]',
          stylePrimary: 'text-[#FFFFFF]',
          styleSecond: 'text-[#FFFFFF]',
        }
      case 'preOrder':
        return {
          primary: 'Đặt trước ngay',
          second: second,
          subPrimary: 'ngày',
          styleBtn: 'bg-[#FF0000] rounded-sm border border-[#FF0000]',
          stylePrimary: 'text-[#FFFFFF]',
          styleSecond: 'text-[#FFFFFF]',
        }
      case 'installment':
        return {
          primary: 'Trả góp',
          second: second,
          styleBtn: 'bg-[#000000] rounded-sm',
          stylePrimary: 'text-white',
          styleSecond: 'text-white',
        }
      case 'pay-late':
        return {
          primary: 'Mua trước trả sau',
          styleBtn: 'bg-[#FF0000] rounded-sm border border-[#FF0000]',
          stylePrimary: 'text-[#FFFFFF]',
          styleSecond: 'text-[#FFFFFF]',
        }
      case 'disable':
        return {
          primary: 'Liên hệ',
          styleBtn: 'bg-[#FF0000] rounded-sm border border-[#FF0000]',
          stylePrimary: 'text-[#FFFFFF]',
          styleSecond: 'text-[#FFFFFF]',
          disable: true,
        }

      default:
        return {
          primary: '',
          second: '',
          styleBtn: '',
          stylePrimary: '',
          styleSecond: '',
        }
    }
  }
  return (
    <button
      type='button'
      ref={buttonRef}
      id={type}
      onClick={ev => {
        setId(ev.currentTarget.id)
        onClick()
      }}
      disabled={(isProcessing && id === type) || renderBtn(type)?.disable}
      className={`${
        className ? className : renderBtn(type)?.styleBtn
      } flex flex-wrap h-[48px] w-full content-center items-center justify-center`}
    >
      <span
        className={`${
          innerClassName ? innerClassName : renderBtn(type)?.stylePrimary
        } block w-full px-2 font-bold`}
      >
        <>
          {isPreOrderButton ? (
            <>
              {isProcessing && id === type ? (
                <Loading />
              ) : (
                renderBtn(type)?.primary
                // ' ' +
                // date +
                // ' ' +
                // renderBtn(type)?.subPrimary
              )}
            </>
          ) : (
            <>
              {isProcessing && id === type ? (
                <Loading />
              ) : (
                renderBtn(type)?.primary
              )}
            </>
          )}
        </>
        {second !=='' && (
        <div className='text-xs font-bold'>{second}</div>
      )}
      </span>
      
    </button>
  )
}
export default ProductButton
